import { useParams } from 'react-router-dom';
import { DashboardLayout } from '@/components/layout/DashboardLayout.tsx';
import { Skeleton } from '@/components/ui/skeleton';
import { useUserView } from '@/hooks/useUserViews';
import { InvoiceViewRenderer } from '@/components/views/InvoiceViewRenderer';
import { DeliverableViewRenderer } from '@/components/views/DeliverableViewRenderer';

export function UserViewPage() {
  const { viewId } = useParams<{ viewId: string }>();
  const { data, isLoading, error } = useUserView(viewId);

  if (isLoading) {
    return (
      <DashboardLayout title="Loading...">
        <div className="space-y-3">
          {[...Array(5)].map((_, i) => (
            <Skeleton key={i} className="h-16 w-full" />
          ))}
        </div>
      </DashboardLayout>
    );
  }

  if (error || !data?.view) {
    return (
      <DashboardLayout title="View Not Found">
        <div className="rounded-lg border border-destructive bg-destructive/10 p-4">
          <p className="text-sm text-destructive">
            {error ? `Failed to load view: ${(error as Error).message}` : 'View not found'}
          </p>
        </div>
      </DashboardLayout>
    );
  }

  const view = data.view;

  switch (view.view_type) {
    case 'invoice_list':
      return <InvoiceViewRenderer view={view} />;
    case 'deliverable_list':
      return <DeliverableViewRenderer view={view} />;
    default:
      return (
        <DashboardLayout title={view.name}>
          <div className="rounded-lg border p-4">
            <p className="text-muted-foreground">
              Unsupported view type: {view.view_type}
            </p>
          </div>
        </DashboardLayout>
      );
  }
}
